import { useNavigate } from "react-router";

import {
  useCheckUserRole,
  useListDataWithLoadMoreForDeliveryOrder,
} from "../../../hooks";
import { parseDeliveryOrders } from "../../../graphql/utils";
import {
  DeliveryOrderProps,
  DeliveryOrderPage as Component,
} from "../../../components/pages/deliveryOrder/DeliveryOrderPage";

export const DeliveryOrderPage = () => {
  const navigate = useNavigate();

  const {
    data,
    variables: { order },
    handlers: { onSortClick, onLoadMoreClick },
  } = useListDataWithLoadMoreForDeliveryOrder();

  useCheckUserRole();

  if (!data?.deliveryOrders && !data?.deliveryOrdersWithKeywords) {
    return null;
  }

  const props: DeliveryOrderProps = {
    deliveryOrders: data.deliveryOrders
      ? parseDeliveryOrders(data.deliveryOrders)
      : parseDeliveryOrders(data.deliveryOrdersWithKeywords),
    order,
    onSortClick,
    onRowClick: (deliveryOrderId: string) => {
      navigate(`/deliveryOrder/${deliveryOrderId}`);
    },
    onLoadMoreClick,
  };

  return <Component {...props} />;
};
